import React from "react";

import WB from 'assets/icons/marketplaceIcons/iconWB.svg';
import ozon from 'assets/icons/marketplaceIcons/iconOzon.svg';
import sb from 'assets/icons/marketplaceIcons/iconSber.svg';
import ali from 'assets/icons/marketplaceIcons/iconAli.svg';
import yandex from 'assets/icons/marketplaceIcons/iconYandex.svg';
import lemanaPro from 'assets/icons/marketplaceIcons/iconLemanaPro.svg';
import system from 'assets/icons/commons/main-circle-icon.svg';

interface IIconProps {
    marketSource: string;
    width: number;
    height: number;
    customClassName?: string;
}

const Icon: React.FC<IIconProps> = ({marketSource, width, height, customClassName}) => {
    marketSource = marketSource.indexOf('LK') === 0 ? 'LK' : marketSource

    const imageSrc: any = {
        'Wildberries': WB,
        'Ozon': ozon,
        'SberMegaMarket': sb,
        'Yandex': yandex,
        'LemanaPro': lemanaPro,
        'AliExpress': ali,
        'SystemPublicWH': system,
        'LK': system,
    }

    const src = imageSrc[marketSource] ?? ''
    return (
        src && <img src={src} width={width} height={height} alt="" className={customClassName}/>
    )
}

export default Icon;